import Backdraw from "../Backdraw";
import ModalWrapper from "./ModalWrapper";
import Props from "./props";
import React from "react";
import Styled from "./styled";

const Modal: React.FC<Props> = ({ children, open = false, onBackdrawClick }) => {
    return (
        <Styled open={open}>
            <Backdraw open={open} onClick={onBackdrawClick} />
            <ModalWrapper open={open}>{children}</ModalWrapper>
        </Styled>
    );
};

export default Modal;
